import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { formGroupCheckboxDefaultProps, formGroupCheckboxPropTypes } from "../FormGroupCommonPropTypes";
import CommonWrapper from "../Wrappers/CommonWrapper";
import RenderErrors from "./RenderErrors";
import { showErrors } from "../commonFunctions";
var RenderCheckbox = function RenderCheckbox(props) {
  var input = props.input,
    label = props.label,
    classConfig = props.classConfig,
    _props$meta = props.meta,
    touched = _props$meta.touched,
    error = _props$meta.error,
    wrapperClassName = props.wrapperClassName,
    disabled = props.disabled,
    muteError = props.muteError;
  var show = !muteError && showErrors(touched, error);
  return /*#__PURE__*/React.createElement(CommonWrapper, {
    wrapperClassName: wrapperClassName,
    showErrors: show
  }, /*#__PURE__*/React.createElement("label", {
    // eslint-disable-line jsx-a11y/label-has-associated-control
    className: classConfig.label
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    className: classConfig.input,
    type: "checkbox",
    disabled: disabled
  })), label), /*#__PURE__*/React.createElement(RenderErrors, {
    showErrors: show,
    error: error
  }));
};
RenderCheckbox.propTypes = _objectSpread({}, formGroupCheckboxPropTypes);
RenderCheckbox.defaultProps = _objectSpread({}, formGroupCheckboxDefaultProps);
export default RenderCheckbox;